import React from 'react';

const Spacer = ({ size = 1 }) => <div style={{ width: '100%', height: `${size}em` }} />;

export default Spacer;
